import Label from "../Label/Label";
import styles from "./TextInput.module.scss";

import { forwardRef, InputHTMLAttributes, ReactNode } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  className?: string;
  icon?: ReactNode;
  /** A control inside the right end of the box, such as a clear button.
   *  Unlike icon, it takes clicks. */
  endAdornment?: ReactNode;
}

const TextInput = forwardRef<HTMLInputElement, Props>(
  ({ label, error, name, className, icon, endAdornment, ...props }, ref) => {
    return (
      <div className={`${styles.textInput} ${className ?? ""}`}>
        {label && <Label htmlFor={name}>{label}</Label>}

        <div className={styles.inputWrapper}>
          {icon && <span className={styles.icon}>{icon}</span>}

          <input
            ref={ref}
            name={name}
            className={`${styles.input} ${error ? styles.error : ""}`}
            {...props}
          />

          {endAdornment && <span className={styles.endAdornment}>{endAdornment}</span>}
        </div>

        {error && <span className={styles.errorText}>{error}</span>}
      </div>
    );
  }
);

export default TextInput;
